import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M23.653 42.983a1 1 0 0 0-1.011-.989Q22.14 42 21.63 42c-6.472 0-11.882-.683-16.227-2.04a2 2 0 0 1-1.376-2.237l.843-5.073a5 5 0 0 1 4.5-4.161Q15.015 28 21.632 28q.528 0 1.05.003a1 1 0 0 0 .012-2Q22.166 26 21.632 26q-6.7 0-12.432.497a7 7 0 0 0-6.3 5.825l-.844 5.073a4 4 0 0 0 2.753 4.474Q11.642 44.002 21.63 44q.521 0 1.033-.006a1 1 0 0 0 .989-1.011"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21.63 2c-5.523 0-10 4.477-10 10 0 5.524 4.478 10 10 10 5.524 0 10-4.477 10-10 0-5.524-4.476-10-10-10m0 18a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M33.63 34h-3c-1.332 0-1.332 2 0 2h3v3c0 1.333 2 1.333 2 0v-3h3c1.334 0 1.334-2 0-2h-3v-3c0-1.333-2-1.333-2 0z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M34.63 24c-6.075 0-11 4.924-11 11s4.925 11 11 11c6.077 0 11-4.925 11-11s-4.924-11-11-11m0 20a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9",
      clipRule: "evenodd"
    }
  )
);
var SvgAddUserOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AddUserOutlined_default = SvgAddUserOutlined;

export { AddUserOutlined_default as default };
